/**
 * 查询题目数量
 * @description 查询题目数量
 * @author hxliu
 * @date 2020-3-27
 */
import React from 'react';
import { connect } from 'dva';

import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizContainer,ossFileUtils } = framework_tool
import { ExamPreview } from '../../../../components'
import { modelUtils } from '@/utils';
let { Session } = utils_tool;
let { WizUpload, WizIcon, WizButton } = component_tool;
import { Spin } from 'antd'


class LookPreview extends WizContainer {

    componentName = 'LookPreview';

    constructor(props) {
        super(props);
        this.state = {
            record: props.record,
            id: props.id,
            score: props.score,
            data: null
        }
    }


    _componentWillMount() {
        this._reload(this.props, this.state);
    }

    propsAndStateOnChange = {
        lookPreviewInfo: this._lookPreviewInfo.bind(this),
    };
    _lookPreviewInfo(nextProps, nextState) {
        let lookPreviewInfo = nextProps['lookPreviewInfo'];
        if (lookPreviewInfo && lookPreviewInfo['success']) {
            let data = []
            if (lookPreviewInfo['data']) {
                if (lookPreviewInfo['data']['parts'] && lookPreviewInfo['data']['parts'] instanceof Array) {
                    lookPreviewInfo['data']['parts'].forEach((part, index) => {
                        part['id'] = index
                        if (part['questions'] && part['questions'] instanceof Array) {
                            part['questions'].forEach((question, index) => {
                                //题目图片
                                if (question['img'] && question['img'] != '') {
                                    question['img'] = getOssFilePath(question['img']);
                                }else{
                                    question['img'] = undefined
                                }
                                if (question['type'] === 1) {
                                    question['correct'] = question['correct'].split(',').map(p => parseInt(p))
                                }
                                if (question['type'] === 2 || question['type'] === 0) {
                                    question['correct'] = parseInt(question['correct'])
                                }
                                if (question['type'] === 3) {
                                    let answerObj = JSON.parse(question['correct'])
                                    let answer = new Array();
                                    for (let i = 0; ; i++) {
                                        if (answerObj[i] === undefined) {
                                          break;
                                        } else {
                                          answer[i] = new Array();
                                          for (let j = 0; j < answerObj[i].length; j++) {
                                            answer[i][j] = answerObj[i][j]
                                          }
                                        }
                                      }
                                    question['correct'] = answer
                                }
                                let options = question['options']
                                if (options && options.length) {
                                    options.forEach(o => {
                                        if (o['fileUri'] && o['fileUri'] != '') {
                                            o['img'] = ossFileUtils.getOssUrlBySuffix(o['fileUri']);
                                        }
                                    });
                                }
                            })
                        }

                    })
                }
                lookPreviewInfo['data']['totalScore'] = nextState['score']
            }
            nextState['data'] = lookPreviewInfo['data']
        }
        return true;
    }
    _reload(nextProps, nextState) {
        let id = nextState.id
        let recordValues = Object.assign([], nextState.record)
        let parts = []
        for (let index = 0; index < recordValues.length; index++) {
            const element = recordValues[index];
            
        let chapterCategoryInfoListValues = Object.assign([], element.categoryTabelForm)
        let questionIdsValues = Object.assign([], element.questionTabelForm)
        let chapterCategoryInfoList = []
        let questionIds = []
        chapterCategoryInfoListValues.forEach((val, index) => {
            let { categoryIds, type, difficulty, order, total } = val
            let params = { categoryId: categoryIds, order, total }
            if (type === 0 || type) {
                params = { ...params, type }
            }
            if (difficulty === 0 || difficulty) {
                params = { ...params, difficulty }
            }
            chapterCategoryInfoList.push(params)
        });
        questionIdsValues.forEach((questionInfo, index) => {
            let { id, questionType } = questionInfo
            let params = { questionId: Math.abs(id), questionType }
            questionIds.push(params)
        });
        parts.push({
          index:index,
          chapterCategoryInfoList:chapterCategoryInfoList,
          questionIds:questionIds,
          title:element['title'],
          score:element['score'],
          description: element['description']
        })
        }

        this.doActions([
            {
                path: `${nextProps['lookType']}/lookPreviewInfo`,
                payload: {
                    key: 'lookPreviewInfoKey',
                    apiParams: {
                        id: id,
                        parts: parts
                    }
                }
            },
        ]);
        return false;
    }
    _render() { 
        const { data, title, score } = this.state
        let { lookType } = this.props
        return (
            <Spin tip={'加载中'} spinning={this.props[lookType+'Loading']}>
            <ExamPreview data={data || {}} />
            </Spin>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    
    const lookPreviewInfo = modelUtils.getModelEntity(state[ownProps['lookType']], "lookPreviewInfoKey");
    const load = modelUtils.getLoadingState(state, [ownProps['lookType']]);
    return {
        lookPreviewInfo,
        ...load
    };
};

export default connect(mapStateToProps)(LookPreview);
